define('GameDayCore/GDModel/ValueObjects/Players/Lineup',['require','exports','module','../ValueObjectFactory','../../../GDControl/GameModelLocator/GameModelLocator'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
        GameModelLocator = require('../../../GDControl/GameModelLocator/GameModelLocator');

	VO.create(Lineup);

	function Lineup($data) {
		var vo = VO.ensureVO(this, Lineup),
			data = $data,
			linescore = GameModelLocator.getCurrentGame().getGameData().linescore,
			lineups = data.lineups,
            home = lineups && (lineups[0].team_id === linescore.home_team_id ? lineups[0] : lineups[1]) || {
                players : []
            },
            away = lineups && (home == lineups[0] ? lineups[1] : lineups[0]) || {
                players : []
            };

			vo.home = home;
			vo.away = away;
	}

	return Lineup;
});
